<template>
  <div class="changePwd">
    <div class="changePwd-tips">
      <p class="title">
        <span class="tips-title">修改密码</span>
        <span class="under_line"></span>
        <span class="tips-bar">
          <span class="step1_bar" :class="{stepPass:tipPass1 && tipPass2,stepCurrent:tipPass1}">
            手机效验
            <i class="dot" :class="{pass:tipPass1 && tipPass2}"></i>
          </span>
          <span
            class="step2_bar"
            :class="{stepPass:tipPass1 && tipPass2 && tipPass3,stepCurrent:tipPass1 && tipPass2}"
          >
            设置密码
            <i class="dot" :class="{pass:tipPass1 && tipPass2 && tipPass3}"></i>
          </span>
          <span class="step3_bar" :class="{stepCurrent:tipPass1 && tipPass2 && tipPass3}">修改成功</span>
        </span>
        <span
          class="under_line_move"
          :class="{move_step1:tipPass1,move_step2:tipPass2,move_step3:tipPass3}"
        ></span>
      </p>
    </div>
    <div class="changePwd_content" v-show="!tipPass3">
      <span class="changePwd_logo"></span>
      <el-form
        ref="changePwdForm"
        :model="changePwdForm"
        :rules="changePwdFormRules"
        class="login-form"
        autocomplete="on"
        @submit.native.prevent
      >
        <div class="change-Part">
          <div class="step1" v-show="tipPass1 && !tipPass2">
            <p class="step1-tips">安全校验手机号</p>
            <p class="old_phone">{{userInfo.mobile | hiddenPhoneNum}}</p>
            <div class="check-phonecode-div">
              <el-form-item class="phone-code" prop="phoneCode">
                <el-input
                  ref="phoneCode"
                  v-model.trim="changePwdForm.phoneCode"
                  placeholder="验证码"
                  name="phoneCode"
                  type="text"
                  maxlength="6"
                  autocomplete="off"
                  @keyup.enter.native="nextFn()"
                />
                <el-button
                  :class="{'is-timing':able}"
                  class="codeBtn"
                  :disabled="able"
                  type="primary"
                  @click="getCode"
                >
                  <span v-show="show">获取验证码</span>
                  <span v-show="!show">{{count}} s</span>
                </el-button>
              </el-form-item>
              <el-form-item v-show="false" class="phone-code" prop="phoneCode">
                <el-input
                  ref="phoneCode"
                  v-model.trim="changePwdForm.password"
                  placeholder="验证码"
                  name="phoneCode"
                  type="password"
                  maxlength="6"
                  autocomplete="new-password"
                />
              </el-form-item>

            </div>
          </div>
          <div class="step2" v-show="tipPass1 && tipPass2 && !tipPass3">
            <div class="changePwd-div">
              <el-form-item class="changePwd-pwd" prop="newPwd">
                <el-input
                  ref="newPwd"
                  v-model.trim="changePwdForm.newPwd"
                  placeholder="请输入密码"
                  name="newPwd"
                  :type="pwdSee?'text':'password'"
                  @keyup.enter.native="nextFn()"
                />
                <i class="input-icon" :class="{hidden:pwdSee}" @click="showPwd()"></i>
              </el-form-item>
            </div>
            <p class="step2-tips">密码需为8～16位大小字母、数字组合</p>
          </div>
        </div>
      </el-form>
      <div class="changePwd_control" :class="{beginEdit:!(tipPass1 && tipPass2)}">
        <span
          class="pre-step whiteBtn"
          v-if="tipPass1 && tipPass2"
          :class="{unAble:whiteLikeAble}"
          @click="prevFn()"
        >上一步</span>
        <span
          class="next-step blueBtn"
          :class="{unAble:blueLikeAble}"
          @click="nextFn()"
        >{{prevText}}</span>
      </div>
    </div>
    <div class="step3" v-show="tipPass1 && tipPass2 && tipPass3">
      <span class="success-logo"></span>
      <div class="success-tips">
        <p class="success-title">修改成功</p>
      </div>
    </div>
  </div>
</template>

<script>
import user from "@/api/user";
export default {
  name: "changePwd",
  components: {},
  data() {
    const validatePhoneCode = (rule, value, callback) => {
      if (value.length != 6) {
        callback(new Error("请输入短信验证码"));
      } else {
        callback();
      }
    };
    const validatePassword = (rule, value, callback) => {
      var reg = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[\S]{8,16}$/;
      if (value.length < 8 || value.length > 16) {
        callback(new Error("密码需为8～16位大小字母、数字组合"));
      } else if (!reg.test(value)) {
        callback(new Error("密码需为8～16位大小字母、数字组合"));
      } else {
        callback();
      }
    };
    return {
      prevText: "下一步",
      tipPass1: true,
      phonePassed: false,
      tipPass2: false,
      tipPass3: false,
      show: true,
      able: false,
      whiteLikeAble: false,
      blueLikeAble: false,
      timer: null,
      count: "",
      pwdSee: false,
      changePwdForm: {
        phoneCode: "",
        newPwd: ""
      },
      changePwdFormRules: {
        phoneCode: [
          { required: true, trigger: "blur", validator: validatePhoneCode }
        ],
        newPwd: [
          { required: true, trigger: "blur", validator: validatePassword }
        ]
        // code: [{ required: true, trigger: "blur",validator: validateCode }],
        // phoneCode: [
        //   { required: true, trigger: "blur",validator: validatePhoneCode },
        //   { type: "number", message: "验证码应为数字值", trigger: "blur" }
        // ]
      }
    };
  },
  props: {
    userInfo: {
      type: Object,
      default: {}
    }
  },
  computed: {},
  watch: {},
  methods: {
    getCode() {
      user
        .getBackPwdCheck(this.userInfo.mobile)
        .then(response => {
          // this.$Message.success(response.data.message);
        })
        .catch(error => {
          console.log(error);
        });
      // 发送请求获取验证码
      this.able = true;
      // 倒计时
      const TIME_COUNT = 90;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.show = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.show = true;
            this.able = false;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    handCheckCode() {
      this.$refs.changePwdForm.validateField("phoneCode", valid => {
        if (!valid) {
          user
            .resetPwdCheck({
              mobile: this.userInfo.mobile,
              mobile_verify_code: this.changePwdForm.phoneCode
            })
            .then(response => {
              // this.$Message.success(response.data.message);
              this.prevText = "确认修改";
              this.tipPass2 = true;
              this.phonePassed = true
            })
            .catch(error => {
              console.log(error);
              if (!this.agreeMent) {
                if (
                  document.getElementsByClassName("el-message").length === 0
                ) {
                  this.$Message({ message: error, type: "warning" });
                }
                return;
              }
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handCheckNewPwd() {
      this.$refs.changePwdForm.validateField("newPwd", valid => {
        if (!valid) {
          user
            .resetPwd({
              password: this.changePwdForm.newPwd
            })
            .then(response => {
              this.$Message.success({message:response.data.message + '，请重新登录',duration:2000});
              let _this = this
              setTimeout(function(){
                user
                  .logOut()
                  .then(res => {
                    _this.$router.push({ name: "login" });
                  })
                  .catch(err => {
                    console.log(err);
                  });
              },2500)
              this.tipPass3 = true;
            })
            .catch(error => {
              console.log(error);
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    showPwd() {
      this.pwdSee = !this.pwdSee;
      this.$nextTick(() => {
        this.$refs.newPwd.focus();
      });
    },
    prevFn() {
      if (this.whiteLikeAble) {
        return;
      }
      if (this.tipPass1 && this.tipPass2 && !this.tipPass3) {
        this.prevText = "下一步";
        this.tipPass2 = false;
      }
    },
    nextFn() {
      if (this.blueLikeAble) {
        return;
      }
      if (this.tipPass1 && !this.tipPass2) {
        if (this.phonePassed) {
          this.prevText = "确认修改";
          this.tipPass2 = true;
        } else {
          this.handCheckCode();
        }
      } else if (this.tipPass1 && this.tipPass2 && !this.tipPass3) {
        this.handCheckNewPwd();
      }
    }
  },
  created() {},
  mounted() {},
  beforeCreate() {}
};
</script>
<style lang='scss' scoped>
.changePwd {
  position: relative;
  .changePwd-tips {
    width: 640px;
    margin: 30px 40px 0;
    border-bottom: 1px solid #e5e5e5;
    .title {
      color: #4c4c4c;
      font-family: Microsoft YaHei;
      font-weight: 700;
      font-size: 20px;
      line-height: 40px;
      letter-spacing: 0px;
      text-align: left;
      padding-left: 51px;
      position: relative;
      .under_line {
        width: 60px;
        height: 3px;
        position: absolute;
        bottom: 0;
        left: 60px;
        background-color: orange;
      }
      .tips-bar {
        color: #b2b2b2;
        font-family: Microsoft YaHei;
        font-weight: 400;
        font-size: 16px;
        line-height: normal;
        letter-spacing: 0px;
        text-align: left;
        padding-left: 236px;
        .stepCurrent {
          color: #4c4c4c;
        }
        .stepPass {
          color: #4e9e2f;
        }

        .dot {
          background: #c9c9c9;
          width: 3px;
          height: 3px;
          border-radius: 3px;
          display: inline-block;
          margin: 0 5px 4px;
          margin-bottom: 4px;
        }
        .pass {
          background: #4e9e2f;
        }
      }
      .under_line_move {
        width: 60px;
        height: 2px;
        position: absolute;
        bottom: 0;
        left: 376px;
        background-color: orange;
      }
      .move_step1 {
        left: 376px;
      }
      .move_step2 {
        left: 464px;
      }
      .move_step3 {
        left: 551px;
      }
    }
  }
  .changePwd_content {
    width: 400px;
    height: 260px;
    border-radius: 6px;
    background: #f3f2f0;
    position: absolute;
    left: 165px;
    top: 150px;
    .changePwd_logo {
      width: 112px;
      height: 112px;
      position: absolute;
      top: -56px;
      left: 144px;
      display: inline-block;
      background: url("../../../assets/images/icon-3.png") no-repeat center;
    }
    .change-Part {
      margin-top: 70px;
      .step1 {
        .step1-tips {
          color: #999999;
          font-family: Microsoft YaHei;
          font-weight: 400;
          font-size: 12px;
          line-height: normal;
          letter-spacing: 0px;
          text-align: center;
        }
        .old_phone {
          color: #000000;
          font-family: Verdana;
          font-weight: 400;
          font-size: 18px;
          line-height: normal;
          letter-spacing: 0px;
          text-align: center;
        }
        .check-phonecode-div {
          margin-top: 30px;
          margin-left: 70px;
          width: 150px;
          position: relative;
          .el-input {
            width: 148px;
            .el-input__inner {
              height: 42px;
              line-height: 42px;
            }
          }
          .el-button.codeBtn {
            width: 100px;
            height: 40px;
            position: absolute;
            right: -110px;
            top: 0;
            padding: 0;
            color: #fff;
            border-radius: 6px;
            background: #4981f2;
            box-shadow: inset 0px -3px 0px 0 #3f79ee, 0px 2px 0px 0 #e5e5e5;
          }
        }
      }
      .step2 {
        overflow: hidden;
        .step2-tips {
          color: #999999;
          font-family: Microsoft YaHei;
          font-weight: 400;
          font-size: 12px;
          line-height: normal;
          letter-spacing: 0px;
          // padding: 0 70px;
          text-align: center;
          margin-top: 14px;
        }
        .changePwd-div {
          margin-top: 19px;
          .changePwd-pwd {
            width: 260px;
            height: 40px;
            border-radius: 6px;
            background: #ffffff;
            border: 1px solid #cccccc;
            box-shadow: inset 3px 3px 0px 0 #f2f2f2;
            margin: 0 auto;
            .input-icon {
              width: 16px;
              height: 10px;
              background: url("../../../assets/images/icons.png") no-repeat -78px -22px;
              display: inline-block;
              position: absolute;
              right: 15px;
              top: 16px;
              cursor: pointer;
            }
            .input-icon.hidden {
              background: url("../../../assets/images/icons.png") no-repeat -105px -22px;
            }
          }
        }
      }
      .step3 {
        .step3-tips {
          color: #999999;
          font-family: Microsoft YaHei;
          font-weight: 400;
          font-size: 14px;
          line-height: normal;
          letter-spacing: 0px;
          text-align: center;
        }
        .new_phone {
          color: #000000;
          font-family: Verdana;
          font-weight: 400;
          font-size: 18px;
          line-height: normal;
          letter-spacing: 0px;
          text-align: center;
        }
        .check-newphonecode-div {
          margin-top: 30px;
          margin-left: 70px;
          width: 260px;
          position: relative;
          .el-form-item {
            margin-bottom: 10px;
          }
          .el-input {
            width: 258px;
            .el-input__inner {
              height: 42px;
              line-height: 42px;
            }
          }
        }
        .againSendMsg-div {
          color: #999999;
          font-family: Microsoft YaHei;
          font-weight: 400;
          font-size: 12px;
          letter-spacing: 0px;
          text-align: right;
          .againSendMsg {
            color: #4981f2;
            cursor: pointer;
          }
        }
      }
    }
    .changePwd_control {
      position: absolute;
      bottom: -14px;
      left: 55px;
      height: 28px;
      span {
        cursor: pointer;
        width: 128px;
        height: 28px;
        margin: 0 6px;
        border-radius: 14px;
        display: inline-block;
        text-align: center;
        color: #4981f2;
        font-family: Microsoft YaHei;
        line-height: 28px;
        font-size: 14px;
        letter-spacing: 0px;
        background: #ffffff;
        border: 1px solid #4981f2;
        box-shadow: inset 0px -2px 0px 0 #cccccc, 0px 2px 0px 0 #e5e5e5;
      }
      .next-step {
        color: #ffffff;
        background: #4981f2;
        box-shadow: inset 0px -3px 0px 0 #3f79ee, 0px 2px 0px 0 #e5e5e5;
      }
    }
    .changePwd_control.beginEdit {
      left: 135px;
    }
  }
  .step3 {
    height: 234px;
    width: 200px;
    position: absolute;
    left: 260px;
    top: 215px;
    .success-logo {
      width: 170px;
      height: 170px;
      display: inline-block;
      background: url("../../../assets/images/icon-3a.png") no-repeat center;
      margin-left: 15px;
    }
    .success-tips {
      .success-title {
        margin-top: 10px;
        color: #000;
        font-family: Microsoft YaHei;
        font-weight: 400;
        font-size: 22px;
        line-height: normal;
        letter-spacing: 0px;
        text-align: center;
        margin-bottom: 6px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/index/safetyCenter/changePwd.vue